import KnowledgeUniversePitchDeck from './KnowledgeUniversePitchDeck';

export default function App() {
  return <KnowledgeUniversePitchDeck />;
}
